function filtersSort() {
  const sort = document.querySelector(".filters-sort");
  const sort_listitem = document.querySelectorAll(".filters-sort-list__item");
  const activ = document.querySelector(".filters-sort-list__item--activ");
  const dropdown = document.querySelector(".filters-sort-list__item--dropdown");

  if (!sort || !activ || !dropdown) {
    return;
  }

  if (sort_listitem.length < 2) {
    return;
  }

  
  sort.addEventListener("click", () => {
    sort.classList.toggle("filters-sort--activ");
  });

  dropdown.addEventListener("click", () => {

    let value1 = sort_listitem[1].getAttribute("data-filters-sort");

    let dropdown_value = dropdown.getAttribute("data-filters-sort");
    let dropdown_text = dropdown.textContent;

    if (value1 === dropdown_value) {
      const value0 = sort_listitem[0].getAttribute("data-filters-sort");
      const text0 = activ.textContent;

      sort_listitem[0].setAttribute("data-filters-sort", value1);
      activ.textContent = dropdown_text;

      sort_listitem[1].setAttribute("data-filters-sort", value0);
      dropdown.textContent = text0;
    }
  });
}

export { filtersSort };
